// @flow
export const LICENSE_MODULE_NAME: 'license' = 'license';

export const LICENSE_ACTION_TYPE: {
    GET_LICENSE_LIST: 'GET_LICENSE_LIST',
} = {
    GET_LICENSE_LIST: 'GET_LICENSE_LIST',
};

export const LICENSE_STATUS: {
    ACTIVE: 1,
    BLOCKED: 3,
    EXPIRED: 5,
} = {
    ACTIVE: 1,
    BLOCKED: 3,
    EXPIRED: 5,
};

export const LICENSE_TYPE: {
    BASE: 8,
    BASE_PREMIUM: 1,
    BETA: 2,
    CROSS_GRADE: 10,
    EDUCATIONAL: 3,
    NFT: 5,
    PUBLIC_SECTOR: 6,
    RENEWAL: 7,
    SUCCESSIVE: 4,
    TRIAL: 9,
} = {
    BASE: 8,
    BASE_PREMIUM: 1,
    BETA: 2,
    CROSS_GRADE: 10,
    EDUCATIONAL: 3,
    NFT: 5,
    PUBLIC_SECTOR: 6,
    RENEWAL: 7,
    SUCCESSIVE: 4,
    TRIAL: 9,
};

export const LICENSE_SORT_TYPE: {
    ASC: 1,
    DEFAULT_SORT: 3,
    DESC: 2,
} = {
    ASC: 1,
    DEFAULT_SORT: 3,
    DESC: 2,
};
